import {
  API_REGIONS,
  Client,
  enableCache,
  ChannelRepository,
  MessageRepository,
  MessageContentType,
  getSubChannelTopic,
  subscribeTopic,
  disconnectClient,
} from "@amityco/ts-sdk";
import { AMITY_KEY, API_IP } from "../../global_variables";
import { useEffect, useState } from "react";
import axios from "axios";

export async function amityLogin(userId: string, displayName: string) {
  const client = Client.createClient(AMITY_KEY, API_REGIONS.US);
  const sessionHandler: Amity.SessionHandler = {
    sessionWillRenewAccessToken(renewal: Amity.AccessTokenRenewal) {
      renewal.renew();
    },
  };
  await Client.login(
    { userId: userId, displayName: displayName },
    sessionHandler
  );
}

export async function AmityLogout() {
  await Client.logout();
  console.log("Logout");
}

export async function createChannel(usernames: string[]) {
  var displayname = "";
  for (let i = 0; i < usernames.length; i++) {
    displayname = "" + displayname + usernames[i];
  }
  const newChannel = {
    //avatarFileId: 'fileId',
    displayName: displayname,
    tags: ["tag"],
    // possible values for type = 'broadcast' | 'conversation' | 'community' | 'live';
    type: "conversation" as Amity.ChannelType,
    userIds: usernames,
    metadata: {
      data: "anything",
    },
  };

  const { data: channel } = await ChannelRepository.createChannel(newChannel);
  return channel;
}

export async function createTextMessage(
  channelID: string,
  text: string,
  creator: string
) {
  const textMessage = {
    subChannelId: channelID,
    dataType: MessageContentType.TEXT,
    data: {
      text: text,
    },
    tags: ["tag1", "tag2"],
    metadata: {
      data: {
        sender: creator,
      },
    },
  };

  const { data: message } = await MessageRepository.createMessage(textMessage);

  return message;
}

const disposers: Amity.Unsubscriber[] = [];

const subscribeSubChannel = (subChannel: Amity.SubChannel) =>
  disposers.push(subscribeTopic(getSubChannelTopic(subChannel)));

export function getMessages<T>(channel: T) {
  const [messages, setMessages] = UseState<Amity.Message[]>();

  UseEffect(() => {
    const unsubscribe = MessageRepository.getMessages(
      { subChannelId: "subChannelId" },
      ({ data: messages, onNextPage, hasNextPage, loading, error }) => {
        setMessages(messages);
        subscribeSubChannel({} as Amity.SubChannel);
      }
    );

    disposers.push(unsubscribe);

    return () => {
      disposers.forEach((fn) => fn());
    };
  }, []);

  return messages;
}

//  This function will send the new channel details to the API
//  channelID is the channel object
//  usernames is a array of strings containing the users involved
export async function registerChannel(
  channelId,
  userIds: string[],
  bookingId?: string | number | null,
  subChannelId?: string | null,
) {
  try {
    const login_token = localStorage.getItem("token");
    const url = `${API_IP}/api/amity/channels`;
    const axiosReqConfig = {
      url: url,
      method: "post",
      headers: { Authorization: `Bearer ${login_token}` },
      data: {
        channel: channelId,
        subChannelId: subChannelId ?? null,
        userIds: userIds,
        booking_id: bookingId ?? null,
      },
    };
    const { data } = await axios(axiosReqConfig);
    console.log(data);
  } catch (error) {
    console.error(error);
  }
  return;
}

//  This function will get the the list of all registered channels contatining "userId"
//  and return and array of objects, each object will contain 2 parameters:
//  channel_code:   the code for the channel
//  userName:       the username of the other user in the channel
/*
    function return example:
    
    Array [
      Object {
        "channel_code": "649bbc5e467796d505133f32",
        "userName": "my-user-id",
      },
    ]
*/
export async function getChannels(userId) {
  console.log(userId);
  var data;
  try {
    const login_token = localStorage.getItem("token");
    const url = `${API_IP}/api/amity/channels?username=${userId}`;
    /*  dont use this, other method works
          const axiosReqConfig = {
          url: url,
          method: 'get',
          headers: { 'Authorization': `Bearer ${device_token}`},
          params: { username: userId }
        };
*/
    data = await axios.get(`${url}`, {
      headers: { Authorization: `Bearer ${login_token}` },
    });
    console.log(data.data);
  } catch (error) {
    console.error(error);
  }
  return data.data;
}
